import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const requestShortCloseQuery = async ({ formValues, poId }) => {
  const {
    reason,
    otherReason,
    level1Assignee,
    level2Assignee,
    remarks,
    level1RoleIdentifier,
    level2RoleIdentifier
  } = formValues;

  const payload = {
    purchaseOrderId: poId,
    shortCloseReasonId: reason,
    otherReason,
    remarks,
    approvers: [
      {
        roleIdentifier: level1RoleIdentifier,
        approverType: level1RoleIdentifier === 'vendor' ? 1 : 2,
        approver: level1Assignee,
        level: 1
      },
      ...(level2RoleIdentifier
        ? [{
          roleIdentifier: level2RoleIdentifier,
          approverType: level2RoleIdentifier === 'vendor' ? 1 : 2,
          approver: level2Assignee,
          level: 2
        }]
        : [])
    ]
  };
  const response = await axios.put(apiurl?.initiateShortClose, payload);
  return response.data;
};

const requestShortClose = () => {
  const queryClient = useQueryClient();

  return useMutation(requestShortCloseQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getPOList');
    }
  });
};

export default requestShortClose;
